import { useQuery } from '@tanstack/react-query';
import { assessmentGetPendingAssessment } from 'lib/api/firebase/apis/apis';
import { queryKeyFactory } from 'lib/utils/queryKeyFactory';

export type GetPendingAssessmentReturnType = Awaited<
  ReturnType<typeof assessmentGetPendingAssessment>
>['data'];

export function useGetPendingAssessmentData(patientId: string) {
  return useQuery({
    queryKey: queryKeyFactory.assessment.pending(patientId),
    queryFn: () =>
      assessmentGetPendingAssessment({ patientId }).then(_ => _.data)
  });
}
